/*
 * @Description: 功能描述
 * @Author: yy
 * @Date: 2019-05-31 14:47:28
 * @LastEditors: yy
 * @LastEditTime: 2019-08-30 15:09:28
 */
/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './AdminKOL.css';
import Calendar from '../../components/Calendar'
import Link from '../../components/Link'
import loadingGif from './loading.gif'
import BrandComplete from '../../components/BrandComplete'
import AdminBackNav from '../adminBackNav/adminBackNav';

const emotionList=[
  {
    type:'0',
    class:'不选择'
  },{
    type:1,
    class:'推荐'
  },{
    type:2,
    class:'好感'
  },{
    type:3,
    class:'中立'
  },{
    type:4,
    class:'差评'
  },{
    type:5,
    class:'反感'
  }
]


const platformList=[
  {
    type:'wx',
    class:'微信'
  },{
    type:'wb',
    class:'微博'
  },{
    type:'zh',
    class:'知乎'
  },{
    type:'tt',
    class:'头条'
  },{
    type:'wk',
    class:'悟空问答'
  }
]

const tableTit=[
  '',
  'KOL名称',
  // '认证方式',
  '文章url',
  '文章标题',
  '阅读数 转发数',
  '评论数',
  '发布日期',
  'DB值',
  '关联品牌&感情倾向'
]

class AdminKOL extends React.Component {
  
  constructor(){
    super()
    this.state={
      brandName:'',
      kolName:'',
      emotion:0,
      platform:'wx',


      timeStartShow:false,
      timeEndShow:false,
      timeStart:'',
      timeEnd:'',
      tableData:[],

      files:[],
      id:null,
      companyName:null,
      loading:false
    }
    this.isCalendarCon=false

    this.saveToState=this.saveToState.bind(this)
    this.saveFile=this.saveFile.bind(this)
    this.enCalendarCon=this.enCalendarCon.bind(this)
    this.ovCalendarCon=this.ovCalendarCon.bind(this)
    this.closeCalendarStart=this.closeCalendarStart.bind(this)
    this.closeCalendarEnd=this.closeCalendarEnd.bind(this)
    // this.handChange=this.handChange.bind(this)
    this.getBrandFullName=this.getBrandFullName.bind(this)
    
  }
  closeCalendarStart=(time)=>{
    this.setState({timeStart:time,timeStartShow:false})
  }
  closeCalendarEnd=(time)=>{
    this.setState({timeEnd:time,timeEndShow:false})
  }
  
  enCalendarCon=()=>{
    this.isCalendarCon=true
  }
  ovCalendarCon=()=>{
    this.isCalendarCon=false
  }

  saveFile=()=>{
    // 保存数据到本地
    const {brandName,kolName,emotion,platform,timeStart,timeEnd}=this.state
    if(!timeEnd||!timeStart){
      alert('时间为必选')
    }else{
    const  url=`/dbrankCMS/saveKolList?brandName=${brandName}&kolName=${kolName}&timeStart=${timeStart}&timeEnd=${timeEnd}&emotion=${emotion}&pltform=${platform}`
    console.log(1,url)
    


    const a = document.createElement('a');
    a.textContent = 'download';
    a.download = 'filename';
    a.href =url;
    a.click();
    }
  }


  saveToState=(e)=>{
    const {name,value}=e.target
    this.setState({
      [name]:value,
      
    })
  }

  getKolList=()=>{
    //获取kol账号列表
    const {loading,brandName,kolName,emotion,platform,timeStart,timeEnd}=this.state
    if(!timeEnd||!timeStart){
      alert('时间为必选')
    }else{
      this.setState({loading:true})
      const  url=`/dbrankCMS/getKolList?brandName=${brandName}&kolName=${kolName}&timeStart=${timeStart}&timeEnd=${timeEnd}&emotion=${emotion}&pltform=${platform}`
      const myInit = {
        method: 'GET',
        credentials: 'include', 
        mode: 'cors',
        cache: 'no-cache' 
      };
      fetch(url,myInit)
      .then(response=>response.json())
      .then(data=>{
        this.setState({loading:false})
        if(data.errorCode==2){
          alert('请重新登录！')
          this.setState({tableData:[],})
        }else{
          this.setState({tableData: data.allKolList})
        }
      })
      .catch(e=>{
        console.log('err',e)
        alert('请求失败！')
        this.setState({tableData:[]})
      })

    }
  
  }
  getBrandFullName=(brand)=>{
    this.setState({brandName:brand})
  }





  render() {
    const {loading,brandName,kolName,timeStart,timeEnd,emotion,platform,timeStartShow,timeEndShow,tableData}=this.state
    return (
      <div className={s.root}>
        <AdminBackNav></AdminBackNav>

        <div className={s.container}>
          <h1>KOL管理</h1>
          <div className={s.listBox}>
            <ul>
              <li>
                <label>品牌名称：</label>
                {/* <input  type='text' value={brandName}  placeholder='必填'  name='brandName' onChange={this.saveToState}/> */}
                <BrandComplete getBrand={this.getBrandFullName} inputClass={{width:'150px',height:'20px'}} />

                <label>KOL名称：</label>
                <input  type='text' value={kolName}  name='kolName' onChange={this.saveToState} />
                {/* <i style={{color:'red',fontStyle:'normal'}}>*品牌名称和KOL名称至少要填一个</i> */}
              </li>
              <li>
                  <div>
                  <div className={s.timeItem} onBlur={()=>!this.isCalendarCon?this.setState({timeStartShow:false}):null}  tabIndex='0'>
                    <span className={s.timeInfoTxt}>发布时间：</span>
                    <div className={s.month} onClick={()=>this.setState({timeStartShow:!this.state.timeStartShow})}>
                        <span className={s.monthTxt} >
                          {timeStart}
                          {timeStart!=''?
                          <i className={s.monthTxtClose} onClick={()=>this.setState({timeStart:''})}>清空</i>
                          :null}
                        </span>
                    </div>
                    
                    <Calendar  isShow={timeStartShow} close={this.closeCalendarStart} cycle='日榜'
                        en={this.enCalendarCon}   ov={this.ovCalendarCon} otherlayout={true}
                    />
                  </div>
                  <div className={s.timeItem} onBlur={()=>!this.isCalendarCon?this.setState({timeEndShow:false}):null}  tabIndex='0'>
                    <span className={s.timeInfoTxt}>结束时间：</span>
                    <div className={s.month} onClick={()=>this.setState({timeEndShow:!this.state.timeEndShow})}>
                        <span className={s.monthTxt} >
                          {timeEnd}
                          {timeEnd!=''?
                          <i className={s.monthTxtClose} onClick={()=>this.setState({timeEnd:''})}>清空</i>
                          :null}
                        </span>
                    </div>
                    <div className={s.monthEnd}>
                      <Calendar  isShow={timeEndShow} close={this.closeCalendarEnd} cycle='日榜'
                          en={this.enCalendarCon}   ov={this.ovCalendarCon} otherlayout={true}
                      />
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <label>感情倾向：</label>
                <select onChange={(e)=>this.setState({emotion:e.target.value})}
                  value={emotion}
                  >
                  {emotionList.map(i=>
                    <option key={i.type} value={i.type}>{i.class}</option>
                  )}
                </select>
                <label>平台：</label>
                <select onChange={(e)=>this.setState({platform:e.target.value})}
                  value={platform}
                  >
                  {platformList.map(i=>
                    <option key={i.type} value={i.type}>{i.class}</option>
                  )}
                </select>
              </li>

            </ul>
            <div onClick={this.getKolList} className={s.seaBtn}>搜索</div>
            <div onClick={this.saveFile} className={s.download}>点击导出数据</div>
            {/* <a href='http://10.0.59.1:8081/saveAccountFile?type=0'  download>shshsh</a> */}
          </div>
          
        
        <div className={s.tableBox}>
          {loading?<div><img src={loadingGif} /></div>
          :
          <div>
            {tableData.length>0?
          
          <table >
            <thead>
              <tr>
                {tableTit.map((i,index)=> {
                  if (platform === 'zh' && index === 4) {
                    return <th key={index}>点赞数</th>
                  } else if (platform === 'wb' && index === 4) {
                    return <th key={index}>转发数</th>
                  }
                  return <th key={index}>{i}</th>
                })}
              </tr>
            </thead>
            <tbody>
              {tableData.map((i,index)=>
                <tr key={index}>
                  <th>{index+1}</th>
                  <td>{i.kolName}</td>
                  {/* <td>{i.hasV?'微信认证':'微信非认证'}</td> */}
                  <td>
                    <a href={i.url} target='_blank'>
                      {i.url}
                    </a>
                  </td>
                  <td>{i.tit}</td>
                  <td>{platform === 'zh' ? i.commentsCount : i.readCount}</td>
                  <td>{platform === 'zh' ? i.readCount : i.commentsCount}</td>
                  <td>{i.date}</td>
                  <td>{i.db}</td>
                  <td>
                    {i.brandList.map(j=><span key={j.name}>{j.name}:{j.emotion} </span>)}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          :null}
          </div>
          }
        </div>
        </div>
        
      </div>
    );
  }
}

export default withStyles(s)(AdminKOL);



// WEBPACK FOOTER //
// src/routes/adminKOL/AdminKOL.js